/**
 * Messages for one area of the app (document 15, section 5.1), English and Arabic side by side.
 * Every key lives under `settingsPages`; Arabic plurals have all six CLDR forms.
 */
import * as more from './settingsPages/more.js';
import * as company from './settingsPages/company.js';
import * as data from './settingsPages/data.js';
import * as general from './settingsPages/general.js';
import * as extra from './settingsPages/extra.js';
import * as migration from './settingsPages/migration.js';

export const en = {
  settingsPages: {
    ...more.en,
    ...company.en,
    ...data.en,
    ...general.en,
    ...migration.en,
    ...extra.en,
  },
};

export const ar = {
  settingsPages: {
    ...more.ar,
    ...company.ar,
    ...data.ar,
    ...general.ar,
    ...migration.ar,
    ...extra.ar,
  },
};
